import { ImageResource } from "@/api/generated-api";
import { FC } from "react";

type IPicture = {
  image: ImageResource;
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
} & Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "srcSet">;

const Picture: FC<IPicture> = ({ image, className, style, alt = "Изображение", ...rest }) => {
  const { desktop, mobile } = image;

  const makeSrcSet = (defaultSrc?: string, doubleSrc?: string): string | undefined => {
    if (!defaultSrc) return undefined;
    if (doubleSrc) {
      return `${defaultSrc} 1x, ${doubleSrc} 2x`;
    }
    return defaultSrc;
  };

  return (
    <picture className={className} style={{ display: "block", height: rest.height, width: rest.width, ...style }}>
      {mobile?.webp_default && (
        <source
          type="image/webp"
          media="(max-width: 767px)"
          srcSet={makeSrcSet(mobile.webp_default, mobile.webp_double) || mobile.webp_default}
        />
      )}

      {desktop?.webp_default && (
        <source
          type="image/webp"
          media="(min-width: 768px) and (max-width: 1024px)"
          srcSet={makeSrcSet(desktop.webp_default, desktop.webp_double) || desktop.webp_default}
        />
      )}

      {desktop?.webp_default && (
        <source
          type="image/webp"
          srcSet={makeSrcSet(desktop.webp_default, desktop.webp_double) || desktop.webp_default}
        />
      )}

      {mobile?.jpg_default && (
        <source
          media="(max-width: 767px)"
          srcSet={makeSrcSet(mobile.jpg_default, mobile.jpg_double) || mobile.jpg_default}
        />
      )}

      {desktop?.jpg_default && (
        <source
          media="(min-width: 768px) and (max-width: 1024px)"
          srcSet={makeSrcSet(desktop.jpg_default, desktop.jpg_double) || desktop.jpg_default}
        />
      )}

      <img
        {...rest}
        src={desktop.jpg_default || mobile?.jpg_default || ""}
        srcSet={desktop.jpg_double ? `${desktop.jpg_double} 2x` : desktop.jpg_default}
        alt={alt}
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </picture>
  );
};

export default Picture;
